const PLACARD_TYPE = {
  bulk: "bulk",
  class: "class",
};

const PLACARD_CLASSES_WITH_TEXTBOX = [
  "bg-9",
  "bg-Bulk1_1",
  "bg-Bulk1_2",
  "bg-Bulk1_3",
  "bg-Bulk1_4",
  "bg-Bulk1_5",
  "bg-Bulk1_6",
  "bg-Bulk2_1",
  "bg-Bulk2_2",
  "bg-Bulk2_3",
  "bg-Bulk2_3B",
  "bg-Bulk3",
  "bg-Bulk4_1",
  "bg-Bulk4_2",
  "bg-Bulk4_3",
  "bg-Bulk5_1",
  "bg-Bulk5_2",
  "bg-Bulk6_1",
  "bg-Bulk7",
  "bg-Bulk8",
  "bg-Bulk9",
  "bg-BulkINH",
  "bg-BulkCMB",
];

export { PLACARD_TYPE, PLACARD_CLASSES_WITH_TEXTBOX };
